'use client';

import { FC, useEffect, useState } from 'react';
import Header from './Header';
import { fetchRemoteConfig, firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import { useDispatch } from 'react-redux';
import { setIsOpen } from '@/hotdesk-ui/store/slices/popup.slice';
export const HeaderClientWrapper: FC<{
  languageCode: LanguageCode;
  isDirectory: boolean;
}> = ({
  languageCode,
  isDirectory
}) => {
  const [teamButton, setTeamButton] = useState('');
  const [appCta, setAppCTA] = useState('');
  const [appQrcData, setAppQrcCTA] = useState('');
  const [cta_app, setCtaApp] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const dispatch = useDispatch();
  const getRemoteConfig = async () => {
    try {
      const teamButtonText = await fetchRemoteConfig(RemoteConfigKeys.SETUPTEAMCONTENT, 'object');
      setTeamButton((teamButtonText as Record<string, string>)[languageCode]);
      const appCtaData = await fetchRemoteConfig(RemoteConfigKeys.APP_CTA_CONTENT, 'object');
      setAppCTA((appCtaData as Record<string, string>)[languageCode]);
      const appQrcData = await fetchRemoteConfig(RemoteConfigKeys.QR_LINK, 'object');
      setAppQrcCTA(appQrcData as string);
      const emiratesCta = await fetchRemoteConfig(RemoteConfigKeys.UAE_VZ_CTA, 'boolean');
      setCtaApp(emiratesCta as boolean);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    setIsBannerVisible(cta_app);
  }, [cta_app]);
  const moveToExternalLink = async (link?: string, eventName?: string, target?: string) => {
    if (!!eventName) await firebaseAnalytics(eventName);
    if (!!link) {
      if (!!target) {
        window.open(link, target);
      } else {
        window.location.href = link;
      }
    }
  };
  useEffect(() => {
    getRemoteConfig();
  }, [languageCode]);
  function appQRCode() {
    if (window.innerWidth > 992) {
      dispatch(setIsOpen(true));
    } else {
      window.location.href = appQrcData;
    }
  }
  const handleCloseBanner = () => {
    setIsBannerVisible(false);
  };
  return <>
            <Header isDirectory={isDirectory} languageCode={languageCode} isunleashFetched={true} book_btn_par={appCta} appQRCode={appQRCode} moveToExternalLink={moveToExternalLink} team_btn_par={teamButton} isBannerVisible={isBannerVisible} handleCloseBanner={handleCloseBanner} emiratesCta={cta_app} data-sentry-element="Header" data-sentry-source-file="HeaderClientWerpper.tsx" />
        </>;
};